import Home from './Home';

export default [{
  path: '/',
  component: Home,
  name: 'home',
  props: true,
}, {
  path: '/products/:page?',
  component: Home,
  name: 'products',
  props: true,
}];